import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Principal from '@/views/Principal.vue';
import LoginDorape from '@/views/LoginDorape.vue';
import Prontuario from '@/views/ProntuarioView.vue';
import Config from '@/views/Config.vue';
import Agenda from '@/views/Agenda.vue';
import { store } from '@/store';

const rotas: Array<RouteRecordRaw> = [
	{
		path: '/login',
		name: 'Login',
		component: LoginDorape,
		meta: {
			publica: true
		}
	}
	, {
		path: '/principal',
		name: 'Principal',
		component: Principal
	}
	, {
		path: '/prontuario',
		name: 'Prontuario',
		component: Prontuario
	}
	, {
		path: '/agenda',
		name: 'Agenda',
		component: Agenda
	}
	, {
		path: '/config',
		name: 'Config',
		component: Config
	}
];

const router = createRouter({
	history: createWebHashHistory(),
	routes: rotas
});

router.beforeEach((routeTo, routeFrom, next) => {
	if (!routeTo.meta.publica && !sessionStorage.getItem('TokenProntuarioWeb')) {
		return next({
			path: '/login'
		});
	}

	if (routeTo.meta.publica && sessionStorage.getItem('TokenProntuarioWeb')) {
		return next({
			path: '/principal'
		});
	}

	let existe = false;
	router.getRoutes().forEach(r => {
		if ((r.path).toUpperCase() == (routeTo.path).toUpperCase()) {
			existe = true;
		}
	});

	if (!existe) {
		return next({
			path: '/agenda'
		});
	}

	next();
});

export default router;